import React, { createContext, useContext, useState, useEffect } from 'react';

// Definición de temas predefinidos
const themes = {
  light: {
    name: 'Azul Claro',
    sidebar: {
      background: 'from-blue-50 via-indigo-50 to-blue-100',
      headerBg: 'from-blue-100/80 to-indigo-100/80',
      border: 'blue-200/50',
      text: {
        primary: 'gray-900',
        secondary: 'gray-700',
        muted: 'gray-600'
      }
    },
    accent: {
      primary: 'blue-600',
      secondary: 'indigo-600',
      hover: 'blue-500',
      glow: 'blue-500/50'
    },
    logo: {
      bg: 'from-blue-500 to-indigo-600',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },
  
  ocean: {
    name: 'Océano Profundo',
    sidebar: {
      background: 'from-blue-900 via-cyan-900 to-blue-800',
      headerBg: 'from-cyan-600/15 to-blue-600/15',
      border: 'cyan-700/50',
      text: {
        primary: 'white',
        secondary: 'cyan-100',
        muted: 'cyan-200'
      }
    },
    accent: {
      primary: 'cyan-500',
      secondary: 'blue-400',
      hover: 'cyan-400',
      glow: 'cyan-400/50'
    },
    logo: {
      bg: 'from-cyan-400 to-blue-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  sunset: {
    name: 'Atardecer Cálido',
    sidebar: {
      background: 'from-orange-900 via-red-800 to-pink-900',
      headerBg: 'from-orange-600/15 to-pink-600/15',
      border: 'orange-700/50',
      text: {
        primary: 'white',
        secondary: 'orange-100',
        muted: 'orange-200'
      }
    },
    accent: {
      primary: 'orange-500',
      secondary: 'pink-500',
      hover: 'orange-400',
      glow: 'orange-400/50'
    },
    logo: {
      bg: 'from-orange-400 to-pink-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  forest: {
    name: 'Bosque Místico',
    sidebar: {
      background: 'from-emerald-900 via-green-800 to-teal-900',
      headerBg: 'from-emerald-600/15 to-teal-600/15',
      border: 'emerald-700/50',
      text: {
        primary: 'white',
        secondary: 'emerald-100',
        muted: 'emerald-200'
      }
    },
    accent: {
      primary: 'emerald-500',
      secondary: 'teal-500',
      hover: 'emerald-400',
      glow: 'emerald-400/50'
    },
    logo: {
      bg: 'from-emerald-400 to-teal-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  royal: {
    name: 'Púrpura Real',
    sidebar: {
      background: 'from-purple-900 via-indigo-900 to-violet-900',
      headerBg: 'from-purple-600/15 to-indigo-600/15',
      border: 'purple-700/50',
      text: {
        primary: 'white',
        secondary: 'purple-100',
        muted: 'purple-200'
      }
    },
    accent: {
      primary: 'purple-500',
      secondary: 'indigo-500',
      hover: 'purple-400',
      glow: 'purple-400/50'
    },
    logo: {
      bg: 'from-purple-400 to-indigo-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  midnight: {
    name: 'Medianoche',
    sidebar: {
      background: 'from-gray-900 via-slate-900 to-zinc-900',
      headerBg: 'from-sky-600/15 to-blue-600/15',
      border: 'slate-700/40',
      text: {
        primary: 'white',
        secondary: 'slate-200',
        muted: 'slate-400'
      }
    },
    accent: {
      primary: 'sky-400',
      secondary: 'blue-400',
      hover: 'sky-300',
      glow: 'sky-300/30'
    },
    logo: {
      bg: 'from-sky-500 to-blue-600',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  steel: {
    name: 'Acero Profesional',
    sidebar: {
      background: 'from-slate-800 via-gray-800 to-slate-900',
      headerBg: 'from-slate-600/20 to-gray-600/20',
      border: 'slate-600/40',
      text: {
        primary: 'white',
        secondary: 'slate-200',
        muted: 'slate-400'
      }
    },
    accent: {
      primary: 'slate-300',
      secondary: 'gray-300',
      hover: 'white',
      glow: 'white/15'
    },
    logo: {
      bg: 'from-slate-500 to-gray-600',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  aurora: {
    name: 'Aurora Boreal',
    sidebar: {
      background: 'from-slate-900 via-teal-900 to-emerald-900',
      headerBg: 'from-teal-500/15 to-emerald-500/15',
      border: 'teal-800/40',
      text: {
        primary: 'white',
        secondary: 'teal-100',
        muted: 'teal-300'
      }
    },
    accent: {
      primary: 'teal-400',
      secondary: 'emerald-400',
      hover: 'teal-300',
      glow: 'teal-300/40'
    },
    logo: {
      bg: 'from-teal-400 to-emerald-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  crimson: {
    name: 'Carmesí',
    sidebar: {
      background: 'from-rose-900 via-red-900 to-rose-900',
      headerBg: 'from-red-600/15 to-rose-600/15',
      border: 'red-800/50',
      text: {
        primary: 'white',
        secondary: 'rose-100',
        muted: 'rose-300'
      }
    },
    accent: {
      primary: 'rose-400',
      secondary: 'red-400',
      hover: 'rose-300',
      glow: 'rose-300/40'
    },
    logo: {
      bg: 'from-rose-400 to-red-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  },

  coffee: {
    name: 'Café Oscuro',
    sidebar: {
      background: 'from-stone-900 via-amber-900 to-stone-800',
      headerBg: 'from-amber-600/15 to-yellow-600/15',
      border: 'stone-700/40',
      text: {
        primary: 'white',
        secondary: 'amber-100',
        muted: 'amber-300'
      }
    },
    accent: {
      primary: 'amber-400',
      secondary: 'yellow-400',
      hover: 'amber-300',
      glow: 'amber-300/40'
    },
    logo: {
      bg: 'from-amber-400 to-yellow-500',
      icon: 'white'
    },
    effects: {
      shadow: '2xl',
      blur: 'backdrop-blur-sm'
    }
  }
};

// Configuraciones de comportamiento por defecto
const defaultSettings = {
  theme: 'light',
  customLogo: null,
  appName: 'Elements',
  sidebarPosition: 'left',
  compactMode: false,
  showTooltips: true,
  animationsEnabled: true,
  showBadges: true,
  autoCollapse: true,
  glassEffect: false
};

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme debe usarse dentro de ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Cargar configuración desde localStorage
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem('elements-theme-settings');
      return saved ? { ...defaultSettings, ...JSON.parse(saved) } : defaultSettings;
    } catch (error) {
      console.error('Error cargando configuración de tema:', error);
      return defaultSettings;
    }
  });

  // Guardar configuración en localStorage
  useEffect(() => {
    try {
      localStorage.setItem('elements-theme-settings', JSON.stringify(settings));
    } catch (error) {
      console.error('Error guardando configuración de tema:', error);
    }
  }, [settings]);

  // Obtener tema actual
  const currentTheme = themes[settings.theme] || themes.light;

  // Funciones para actualizar configuración
  const updateTheme = (themeName) => {
    if (themes[themeName]) {
      setSettings(prev => ({ ...prev, theme: themeName }));
    }
  };

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const resetToDefaults = () => {
    setSettings(defaultSettings);
  };

  const value = {
    // Estado actual
    settings,
    currentTheme,
    themes,
    
    // Acciones
    updateTheme,
    updateSettings,
    resetToDefaults,
    
    // Utilidades
    getThemeClasses: (element) => {
      const theme = currentTheme;
      const base = {
        sidebar: `bg-gradient-to-b ${theme.sidebar.background} text-${theme.sidebar.text.primary} border-${theme.sidebar.border}`,
        header: `bg-gradient-to-r ${theme.sidebar.headerBg} border-${theme.sidebar.border}`,
        logo: `bg-gradient-to-br ${theme.logo.bg}`,
        accent: `text-${theme.accent.hover}`,
        activeItem: `bg-gradient-to-r from-${theme.accent.primary}/20 to-${theme.accent.secondary}/20 border-${theme.accent.primary}/30`,
        hoverItem: `hover:bg-white/5 hover:text-${theme.accent.hover}`,
        glow: `shadow-lg shadow-${theme.accent.glow}`
      };
      
      return element ? base[element] : base;
    }
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;